import {
  ApiCart,
  ApiProduct
} from '../../../../services/eaptekaApi/methods/cartGet/types';
import { ProductWithAnalytics } from '../../../products/types';
import { ProductEntity, ProductId } from '../../../types';
import { Cart } from '../../fetchCart';
import { serializeProductFromApi } from './serializeProductFromApi';
import { serializePromocodeFromApi } from './serializePromocodeFromApi';
import { serializeSummaryFromApi } from './serializeSummaryFromApi';

export function serializeCartFromApi(data: ApiCart): Cart {
  return {
    products: data.cartProducts?.reduce<
      ProductEntity<ProductWithAnalytics>
    >(
      (
        byId: ProductEntity<ProductWithAnalytics>,
        product: ApiProduct
      ) => {
        byId[product.id as ProductId] =
          serializeProductFromApi(product);

        return byId;
      },
      {}
    ),
    promocode: data.promocode
      ? serializePromocodeFromApi(data.promocode)
      : null,
    summary: serializeSummaryFromApi(data)
  };
}
